import { Component, Input, OnInit } from '@angular/core';
import { SubscriptionStatus } from '../../models/subscription/subscription.model';

@Component({
    selector: 'subscription-account-alert',
    templateUrl: './subscription-account-alert.component.html',
    styleUrls: ['./subscription-account-alert.component.scss'],
    standalone: false
})
export class SubscriptionAccountAlertComponent implements OnInit {
  @Input() isOrgBillingAdminUser: boolean;
  @Input() subscriptionStatus: string;

  public alertText: string;

  constructor() {}

  ngOnInit(): void {
      if (this.isOutstanding()) {
          this.alertText = 'WARNING: You have one or more outstanding invoices. Go to the Billing page to pay the invoice(s) before any become delinquent and restrict your application usage.';
      } else if (this.isOrgBillingAdminUser) {
          this.alertText = 'ATTENTION: You have one or more delinquent invoices. Your application usage is restricted until the invoice(s) are paid.';
      } else {
          this.alertText = `ATTENTION: Your application usage is restricted because of account delinquency. Contact your Organization Billing Admin to resolve your account's status.`;
      }
  }

  isOutstanding() {
      return this.subscriptionStatus === SubscriptionStatus.OUTSTANDING;
  }

  isDelinquent() {
      return this.subscriptionStatus === SubscriptionStatus.DELINQUENT;
  }
}
